import React from 'react';
import withIcon from '../utilities/withIcon';

const IconHealth = () => {
  return (
    <g>
      <path d="m12.8716 9.9934a2.0425 2.0425 0 0 0 -1.4516 3.4808 2.0536 2.0536 0 0 1 -2.4937.8375 2.2821 2.2821 0 0 1 -1.6463-2.2241v-1.5143a5.295 5.295 0 0 0 4.6953-5.1351c.001-.0137.001-.0273.001-.041v-4.5893a.75.75 0 0 0 -.75-.75h-1.925a.75.75 0 1 0 0 1.5h1.1748v3.7714a3.809 3.809 0 0 1 -3.8047 3.8047h-.2832a3.809 3.809 0 0 1 -3.8047-3.8047v-3.7714h1.1865a.75.75 0 1 0 0-1.5h-1.9365a.75.75 0 0 0 -.75.75v4.5893c0 .0137 0 .0273.001.041a5.295 5.295 0 0 0 4.6955 5.1351v1.4938a3.796 3.796 0 0 0 2.7129 3.6807 4.3132 4.3132 0 0 0 1.2461.1943 3.5329 3.5329 0 0 0 3.073-1.8659c.02.0006.0393.006.06.006a2.0444 2.0444 0 1 0 0-4.0889zm0 2.6885a.644.644 0 1 1 .6445-.644.6445.6445 0 0 1 -.6445.644z" />
    </g>
  );
};

export default withIcon(IconHealth);
